var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "theme-details-inner-form" }, [
    _c("h2", { staticClass: "section-title-sm mb-8" }, [
      _vm._v(_vm._s(_vm.subscriptions) + " " + _vm._s(_vm.i + 2))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "theme-details-form__inputs-list" }, [
      _c(
        "div",
        {
          staticClass:
            "theme-details-form__language-gender-block details-section"
        },
        [
          _c(
            "div",
            { staticClass: "grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-8" },
            [
              _vm.extra_tenants[_vm.i]
                ? _c("theme-radios", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: {
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.language,
                      value: _vm.extra_tenants[_vm.i].language,
                      name:
                        "person[" + _vm.extra_tenants[_vm.i].id + "][language]",
                      options: _vm.languages,
                      isRequired: true
                    }
                  })
                : _c("theme-radios", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: {
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.language,
                      name: "new_person[" + [_vm.i] + "][language]",
                      options: _vm.languages,
                      isRequired: true
                    }
                  }),
              _vm._v(" "),
              _vm.extra_tenants[_vm.i]
                ? _c("theme-radios", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|make_choice",
                        expression: "`required|make_choice`"
                      }
                    ],
                    attrs: {
                      label:
                        _vm.locales &&
                        _vm.locales.subscriptions &&
                        _vm.locales.subscriptions.sex,
                      name:
                        "person[" + _vm.extra_tenants[_vm.i].id + "][title_id]",
                      options: _vm.usersTitleOptions,
                      value: _vm.extra_tenants[_vm.i].title_id,
                      isRequired: true
                    }
                  })
                : _c("theme-radios", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|make_choice",
                        expression: "`required|make_choice`"
                      }
                    ],
                    attrs: {
                      label:
                        _vm.locales &&
                        _vm.locales.subscriptions &&
                        _vm.locales.subscriptions.sex,
                      name: "new_person[" + [_vm.i] + "][title_id]",
                      options: _vm.usersTitleOptions,
                      isRequired: true
                    }
                  })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "theme-details-form__income details-section" }, [
        _c("h2", { staticClass: "section-title-xs" }, [
          _vm._v(
            _vm._s(_vm.subscriptions) +
              " " +
              _vm._s(_vm.i + 2) +
              " " +
              _vm._s(_vm.detailsTitle)
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8" },
          [
            _vm.extra_tenants[_vm.i]
              ? _c("theme-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|alpha_spaces_dash",
                      expression: "`required|alpha_spaces_dash`"
                    }
                  ],
                  attrs: {
                    label: _vm.usersFirstName,
                    name:
                      "person[" + _vm.extra_tenants[_vm.i].id + "][first_name]",
                    isRequired: true,
                    placeholder: _vm.usersFirstNamePlaceholder
                  },
                  model: {
                    value: _vm.extra_tenants[_vm.i].first_name,
                    callback: function($$v) {
                      _vm.$set(_vm.extra_tenants[_vm.i], "first_name", $$v)
                    },
                    expression: "extra_tenants[i].first_name"
                  }
                })
              : _c("theme-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|alpha_spaces_dash",
                      expression: "`required|alpha_spaces_dash`"
                    }
                  ],
                  attrs: {
                    label: _vm.usersFirstName,
                    name: "new_person[" + [_vm.i] + "][first_name]",
                    isRequired: true,
                    placeholder: _vm.usersFirstNamePlaceholder
                  }
                }),
            _vm._v(" "),
            _vm.extra_tenants[_vm.i]
              ? _c("theme-input", {
                  attrs: {
                    label: _vm.usersMiddleName,
                    name:
                      "person[" +
                      _vm.extra_tenants[_vm.i].id +
                      "][middle_name]",
                    placeholder: _vm.usersMiddleNamePlaceholder
                  },
                  model: {
                    value: _vm.extra_tenants[_vm.i].middle_name,
                    callback: function($$v) {
                      _vm.$set(_vm.extra_tenants[_vm.i], "middle_name", $$v)
                    },
                    expression: "extra_tenants[i].middle_name"
                  }
                })
              : _c("theme-input", {
                  attrs: {
                    label: _vm.usersMiddleName,
                    name: "new_person[" + [_vm.i] + "][middle_name]",
                    placeholder: _vm.usersMiddleNamePlaceholder
                  }
                }),
            _vm._v(" "),
            _vm.extra_tenants[_vm.i]
              ? _c("theme-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|alpha_spaces_dash",
                      expression: "`required|alpha_spaces_dash`"
                    }
                  ],
                  attrs: {
                    label: _vm.usersLastName,
                    name:
                      "person[" + _vm.extra_tenants[_vm.i].id + "][last_name]",
                    isRequired: true,
                    placeholder: _vm.usersLastNamePlaceholder
                  },
                  model: {
                    value: _vm.extra_tenants[_vm.i].last_name,
                    callback: function($$v) {
                      _vm.$set(_vm.extra_tenants[_vm.i], "last_name", $$v)
                    },
                    expression: "extra_tenants[i].last_name"
                  }
                })
              : _c("theme-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|alpha_spaces_dash",
                      expression: "`required|alpha_spaces_dash`"
                    }
                  ],
                  attrs: {
                    label: _vm.usersLastName,
                    name: "new_person[" + [_vm.i] + "][last_name]",
                    isRequired: true,
                    placeholder: _vm.usersLastNamePlaceholder
                  }
                }),
            _vm._v(" "),
            _c(
              "div",
              [
                _vm.extra_tenants[_vm.i]
                  ? _c("theme-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|phone_number",
                          expression: "`required|phone_number`"
                        }
                      ],
                      staticClass: "js-unique-phone",
                      attrs: {
                        label: _vm.usersPhoneNumber,
                        name:
                          "person[" +
                          _vm.extra_tenants[_vm.i].id +
                          "][phone_number]",
                        isRequired: true,
                        placeholder: _vm.usersPhoneNumberPlaceholder
                      },
                      on: { blur: _vm.checkPhone },
                      model: {
                        value: _vm.extra_tenants[_vm.i].phone_number,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.extra_tenants[_vm.i],
                            "phone_number",
                            $$v
                          )
                        },
                        expression: "extra_tenants[i].phone_number"
                      }
                    })
                  : _c("theme-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|phone_number",
                          expression: "`required|phone_number`"
                        }
                      ],
                      staticClass: "js-unique-phone",
                      attrs: {
                        label: _vm.usersPhoneNumber,
                        name: "new_person[" + [_vm.i] + "][phone_number]",
                        isRequired: true,
                        placeholder: _vm.usersPhoneNumberPlaceholder
                      },
                      on: { blur: _vm.checkPhone }
                    }),
                _vm._v(" "),
                !!_vm.is_phone_number_unique
                  ? _c("div", [
                      _c("p", { staticClass: "text-red-600 font-semibold" }, [
                        _vm._v(_vm._s(_vm.incomePhoneNumberAlreadyExists))
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "`required`"
                          }
                        ],
                        attrs: { type: "hidden", name: "phone_number_unique" }
                      })
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _vm.extra_tenants[_vm.i]
                  ? _c("theme-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|email",
                          expression: "`required|email`"
                        }
                      ],
                      staticClass: "js-unique-mail",
                      attrs: {
                        label: _vm.usersEmail,
                        name:
                          "person[" + _vm.extra_tenants[_vm.i].id + "][email]",
                        type: "email",
                        isRequired: true,
                        placeholder: _vm.usersEmailPlaceholder
                      },
                      on: {
                        blur: function($event) {
                          return _vm.checkMail(
                            $event,
                            _vm.extra_tenants[_vm.i].id
                          )
                        }
                      },
                      model: {
                        value: _vm.extra_tenants[_vm.i].email,
                        callback: function($$v) {
                          _vm.$set(_vm.extra_tenants[_vm.i], "email", $$v)
                        },
                        expression: "extra_tenants[i].email"
                      }
                    })
                  : _c("theme-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|email",
                          expression: "`required|email`"
                        }
                      ],
                      staticClass: "js-unique-mail",
                      attrs: {
                        label: _vm.usersEmail,
                        name: "new_person[" + [_vm.i] + "][email]",
                        type: "email",
                        isRequired: true,
                        placeholder: _vm.usersEmailPlaceholder
                      },
                      on: { blur: _vm.checkMail }
                    }),
                _vm._v(" "),
                _vm.is_user_already_exists == 1
                  ? _c("div", [
                      _c("p", { staticClass: "text-red-600 font-semibold" }, [
                        _vm._v(_vm._s(_vm.isUserAlreadyExists))
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "`required`"
                          }
                        ],
                        attrs: { type: "hidden", name: "user_already_exists" }
                      })
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.extra_tenants[_vm.i]
              ? _c("functional-calendar", {
                  staticClass: "single-calendar min-w-[250px] md:w-full",
                  attrs: { configs: _vm.calendarConfigs },
                  on: { choseDay: _vm.changeBirthDate },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "datePickerInput",
                        fn: function(props) {
                          return [
                            _c(
                              "theme-input",
                              {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "`required`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.usersDateOfBirth,
                                  value: _vm.birthDate.date
                                    ? _vm.birthDate.date
                                    : "",
                                  name:
                                    "person[" +
                                    _vm.extra_tenants[_vm.i].id +
                                    "][birthdate]",
                                  isExtraInfo: true,
                                  isReadonly: true,
                                  placeholder: _vm.usersBirthPlaceholder,
                                  isRequired: true
                                }
                              },
                              [
                                _c("template", { slot: "extra-info" }, [
                                  _c("i", { staticClass: "icon-calendar" })
                                ])
                              ],
                              2
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2802882102
                  ),
                  model: {
                    value: _vm.birthDate,
                    callback: function($$v) {
                      _vm.birthDate = $$v
                    },
                    expression: "birthDate"
                  }
                })
              : _c("functional-calendar", {
                  staticClass: "single-calendar min-w-[250px] md:w-full",
                  attrs: { configs: _vm.calendarConfigs },
                  on: { choseDay: _vm.changeNewUserBirthDate },
                  scopedSlots: _vm._u([
                    {
                      key: "datePickerInput",
                      fn: function(props) {
                        return [
                          _c(
                            "theme-input",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "`required`"
                                }
                              ],
                              attrs: {
                                label: _vm.usersDateOfBirth,
                                value: _vm.birthDateNewUserComputed,
                                name: "new_person[" + [_vm.i] + "][birthdate]",
                                isExtraInfo: true,
                                isReadonly: true,
                                placeholder: _vm.usersBirthPlaceholder,
                                isRequired: true
                              }
                            },
                            [
                              _c("template", { slot: "extra-info" }, [
                                _c("i", { staticClass: "icon-calendar" })
                              ])
                            ],
                            2
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.birthDateNewUser,
                    callback: function($$v) {
                      _vm.birthDateNewUser = $$v
                    },
                    expression: "birthDateNewUser"
                  }
                }),
            _vm._v(" "),
            _vm.extra_tenants[_vm.i]
              ? _c("theme-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "email",
                      expression: "`email`"
                    }
                  ],
                  attrs: {
                    label: _vm.usersInvoiceEmail,
                    name:
                      "person[" +
                      _vm.extra_tenants[_vm.i].id +
                      "][invoice_mail]",
                    type: "email",
                    placeholder: _vm.usersInvoiceEmailPlaceholder
                  },
                  model: {
                    value: _vm.extra_tenants[_vm.i].invoice_mail,
                    callback: function($$v) {
                      _vm.$set(_vm.extra_tenants[_vm.i], "invoice_mail", $$v)
                    },
                    expression: "extra_tenants[i].invoice_mail"
                  }
                })
              : _c("theme-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "email",
                      expression: "`email`"
                    }
                  ],
                  attrs: {
                    label: _vm.usersInvoiceEmail,
                    name: "new_person[" + [_vm.i] + "][invoice_mail]",
                    type: "email",
                    placeholder: _vm.usersInvoiceEmailPlaceholder
                  }
                }),
            _vm._v(" "),
            _vm.extra_tenants[_vm.i]
              ? _c("theme-input", {
                  attrs: {
                    label: _vm.usersBankAccount,
                    name:
                      "person[" +
                      _vm.extra_tenants[_vm.i].id +
                      "][bank_account]",
                    placeholder: _vm.usersBankAccountPlaceholder
                  },
                  model: {
                    value: _vm.extra_tenants[_vm.i].bank_account,
                    callback: function($$v) {
                      _vm.$set(_vm.extra_tenants[_vm.i], "bank_account", $$v)
                    },
                    expression: "extra_tenants[i].bank_account"
                  }
                })
              : _c("theme-input", {
                  attrs: {
                    label: _vm.usersBankAccount,
                    name: "new_person[" + [_vm.i] + "][bank_account]",
                    placeholder: _vm.usersBankAccountPlaceholder
                  }
                }),
            _vm._v(" "),
            _vm.extra_tenants[_vm.i]
              ? _c("theme-input", {
                  attrs: {
                    label: _vm.usersBic,
                    name: "person[" + _vm.extra_tenants[_vm.i].id + "][bic]",
                    placeholder: _vm.usersBicPlaceholder
                  },
                  model: {
                    value: _vm.extra_tenants[_vm.i].bic,
                    callback: function($$v) {
                      _vm.$set(_vm.extra_tenants[_vm.i], "bic", $$v)
                    },
                    expression: "extra_tenants[i].bic"
                  }
                })
              : _c("theme-input", {
                  attrs: {
                    label: _vm.usersBic,
                    name: "new_person[" + [_vm.i] + "][bic]",
                    placeholder: _vm.usersBicPlaceholder
                  }
                })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "theme-details-form__address details-section" },
        [
          _c("h2", { staticClass: "section-title-xs" }, [
            _vm._v(
              _vm._s(_vm.subscriptions) +
                " " +
                _vm._s(_vm.i + 2) +
                " " +
                _vm._s(_vm.addressTitle)
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8" },
            [
              _vm.extra_tenants[_vm.i]
                ? _c("theme-input", {
                    staticClass: "js-postcode",
                    attrs: {
                      name:
                        "person[" +
                        _vm.extra_tenants[_vm.i].id +
                        "][address][post_code]",
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.post_code,
                      placeholder: _vm.usersPostCodePlaceholder
                    },
                    on: {
                      blur: function($event) {
                        return _vm.checkPcHn($event, _vm.i)
                      }
                    },
                    model: {
                      value: _vm.extra_tenants[_vm.i].address.post_code,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.extra_tenants[_vm.i].address,
                          "post_code",
                          $$v
                        )
                      },
                      expression: "extra_tenants[i].address.post_code"
                    }
                  })
                : _c("theme-input", {
                    ref: "new_person_postcode_" + _vm.i,
                    staticClass: "js-postcode",
                    attrs: {
                      name: "new_person[" + [_vm.i] + "][address][post_code]",
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.post_code,
                      placeholder: _vm.usersPostCodePlaceholder
                    },
                    on: {
                      blur: function($event) {
                        return _vm.checkPcHn($event, _vm.i)
                      }
                    }
                  }),
              _vm._v(" "),
              _vm.extra_tenants[_vm.i]
                ? _c("theme-input", {
                    attrs: {
                      "is-update-model": true,
                      name:
                        "person[" +
                        _vm.extra_tenants[_vm.i].id +
                        "][address][city]",
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.city,
                      placeholder: _vm.usersCityPlaceholder
                    },
                    model: {
                      value: _vm.extra_tenants[_vm.i].address.city,
                      callback: function($$v) {
                        _vm.$set(_vm.extra_tenants[_vm.i].address, "city", $$v)
                      },
                      expression: "extra_tenants[i].address.city"
                    }
                  })
                : _c("theme-input", {
                    ref: "new_person_city_" + _vm.i,
                    attrs: {
                      "is-update-model": true,
                      name: "new_person[" + [_vm.i] + "][address][city]",
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.city,
                      placeholder: _vm.usersCityPlaceholder
                    }
                  })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8" },
            [
              _vm.extra_tenants[_vm.i]
                ? _c("theme-input", {
                    staticClass: "stretch-height",
                    attrs: {
                      name:
                        "person[" +
                        _vm.extra_tenants[_vm.i].id +
                        "][address][street]",
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.street,
                      placeholder: _vm.usersStreetPlaceholder
                    },
                    model: {
                      value: _vm.extra_tenants[_vm.i].address.street,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.extra_tenants[_vm.i].address,
                          "street",
                          $$v
                        )
                      },
                      expression: "extra_tenants[i].address.street"
                    }
                  })
                : _c("theme-input", {
                    ref: "new_person_street_" + _vm.i,
                    staticClass: "stretch-height",
                    attrs: {
                      name: "new_person[" + [_vm.i] + "][address][street]",
                      label:
                        _vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.street,
                      placeholder: _vm.usersStreetPlaceholder
                    }
                  }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-span-1 md:col-span-2 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8"
                },
                [
                  _vm.extra_tenants[_vm.i]
                    ? _c("theme-input", {
                        staticClass: "js-house-number stretch-height",
                        attrs: {
                          name:
                            "person[" +
                            _vm.extra_tenants[_vm.i].id +
                            "][address][house_number]",
                          label:
                            _vm.locales &&
                            _vm.locales.users &&
                            _vm.locales.users.house_number,
                          placeholder: _vm.usersHouseNumberPlaceholder
                        },
                        on: {
                          blur: function($event) {
                            return _vm.checkPostcodeAddress($event, _vm.i)
                          }
                        },
                        model: {
                          value: _vm.extra_tenants[_vm.i].address.house_number,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.extra_tenants[_vm.i].address,
                              "house_number",
                              $$v
                            )
                          },
                          expression: "extra_tenants[i].address.house_number"
                        }
                      })
                    : _c("theme-input", {
                        ref: "new_person_house_number_" + _vm.i,
                        staticClass: "js-house-number stretch-height",
                        attrs: {
                          name:
                            "new_person[" +
                            [_vm.i] +
                            "][address][house_number]",
                          label:
                            _vm.locales &&
                            _vm.locales.users &&
                            _vm.locales.users.house_number,
                          placeholder: _vm.usersHouseNumberPlaceholder
                        },
                        on: {
                          blur: function($event) {
                            return _vm.checkPostcodeAddress($event, _vm.i)
                          }
                        }
                      }),
                  _vm._v(" "),
                  _c("theme-input", {
                    staticClass: "stretch-height",
                    attrs: {
                      name: _vm.usersHouseNumberAppendix,
                      label: _vm.usersHouseNumberAppendixLabel,
                      placeholder: _vm.usersHouseNumberAppendixPlaceholder
                    },
                    model: {
                      value: _vm.usersHouseNumberAppendixValue,
                      callback: function($$v) {
                        _vm.usersHouseNumberAppendixValue = $$v
                      },
                      expression: "usersHouseNumberAppendixValue"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "theme-details-form__family-status details-section" },
        [
          _c("h2", { staticClass: "section-title-xs" }, [
            _vm._v(
              _vm._s(_vm.subscriptions) +
                " " +
                _vm._s(_vm.i + 2) +
                " " +
                _vm._s(_vm.familyStatusTitle)
            )
          ]),
          _vm._v(" "),
          _vm.extra_tenants[_vm.i]
            ? _c("theme-select", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "`required`"
                  }
                ],
                staticClass: "max-w-[300px]",
                attrs: {
                  label: _vm.usersCivilState,
                  value: _vm.extra_tenants[_vm.i].civil_state_id,
                  name:
                    "person[" +
                    _vm.extra_tenants[_vm.i].id +
                    "][civil_state_id]",
                  options: _vm.usersCivilStateOptions,
                  isRequired: true
                }
              })
            : _c("theme-select", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "`required`"
                  }
                ],
                staticClass: "max-w-[300px]",
                attrs: {
                  label: _vm.usersCivilState,
                  name: "new_person[" + [_vm.i] + "][civil_state_id]",
                  options: _vm.usersCivilStateOptions,
                  isRequired: true
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "heme-details-form__income details-section" },
        [
          _c("h2", { staticClass: "section-title-xs" }, [
            _vm._v(
              _vm._s(_vm.subscriptions) +
                " " +
                _vm._s(_vm.i + 2) +
                " " +
                _vm._s(_vm.incomeTitle)
            )
          ]),
          _vm._v(" "),
          _vm.extra_tenants[_vm.i]
            ? _c("theme-checkboxes", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|make_choice",
                    expression: "`required|make_choice`"
                  }
                ],
                attrs: {
                  label: _vm.usersIAm,
                  name:
                    "person[" +
                    _vm.extra_tenants[_vm.i].id +
                    "][type_of_income][]",
                  options: _vm.usersTypeOfIncomeOptions,
                  values: _vm.extra_tenants[_vm.i].types_of_income_array,
                  isRequired: true
                },
                on: { input: _vm.triggerIncomeAdditionalForms }
              })
            : _c("theme-checkboxes", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|make_choice",
                    expression: "`required|make_choice`"
                  }
                ],
                attrs: {
                  label: _vm.usersIAm,
                  name: "new_person[" + [_vm.i] + "][type_of_income][]",
                  options: _vm.usersTypeOfIncomeOptions,
                  isRequired: true
                },
                on: { input: _vm.triggerIncomeAdditionalForms }
              }),
          _vm._v(" "),
          _vm.income_form_work_business
            ? _c("div", [
                _vm.income_form_work
                  ? _c(
                      "div",
                      [
                        _vm.extra_tenants[_vm.i]
                          ? _c("theme-radios", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|make_choice",
                                  expression: "`required|make_choice`"
                                }
                              ],
                              staticClass: "mb-8",
                              attrs: {
                                label: _vm.usersContractType,
                                name:
                                  "person[" +
                                  _vm.extra_tenants[_vm.i].id +
                                  "][working_contract_type_id]",
                                options: _vm.usersContractTypeOptions,
                                isRequired: true,
                                columnDirection: true
                              },
                              on: { input: _vm.triggerContractDuration },
                              model: {
                                value:
                                  _vm.extra_tenants[_vm.i]
                                    .working_contract_type_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.extra_tenants[_vm.i],
                                    "working_contract_type_id",
                                    $$v
                                  )
                                },
                                expression:
                                  "extra_tenants[i].working_contract_type_id"
                              }
                            })
                          : _c("theme-radios", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|make_choice",
                                  expression: "`required|make_choice`"
                                }
                              ],
                              staticClass: "mb-8",
                              attrs: {
                                label: _vm.usersContractType,
                                name:
                                  "new_person[" +
                                  [_vm.i] +
                                  "][working_contract_type_id]",
                                options: _vm.usersContractTypeOptions,
                                isRequired: true,
                                columnDirection: true
                              },
                              on: { input: _vm.triggerContractDuration }
                            })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showDuration && _vm.income_form_work
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "grid grid-cols-1 gap-8 mb-6 md:grid-cols-2 md:gap-8"
                      },
                      [
                        _vm.extra_tenants[_vm.i]
                          ? _c("theme-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|numeric",
                                  expression: "`required|numeric`"
                                }
                              ],
                              attrs: {
                                label: _vm.usersContractDuration,
                                name:
                                  "person[" +
                                  _vm.extra_tenants[_vm.i].id +
                                  "][working_contract_duration]",
                                isRequired: true,
                                placeholder:
                                  _vm.usersContractDurationPlaceholder
                              },
                              model: {
                                value:
                                  _vm.extra_tenants[_vm.i]
                                    .working_contract_duration,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.extra_tenants[_vm.i],
                                    "working_contract_duration",
                                    $$v
                                  )
                                },
                                expression:
                                  "extra_tenants[i].working_contract_duration"
                              }
                            })
                          : _c("theme-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|numeric",
                                  expression: "`required|numeric`"
                                }
                              ],
                              attrs: {
                                label: _vm.usersContractDuration,
                                name:
                                  "new_person[" +
                                  [_vm.i] +
                                  "][working_contract_duration]",
                                isRequired: true,
                                placeholder:
                                  _vm.usersContractDurationPlaceholder
                              }
                            }),
                        _vm._v(" "),
                        _vm.extra_tenants[_vm.i]
                          ? _c("functional-calendar", {
                              staticClass:
                                "single-calendar min-w-[250px] md:w-full",
                              attrs: { configs: _vm.calendarConfigs },
                              on: { choseDay: _vm.changeContractEndDate },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "datePickerInput",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "theme-input",
                                          {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "`required`"
                                              }
                                            ],
                                            attrs: {
                                              label: _vm.usersContractEndDate,
                                              value:
                                                _vm.contractEndDateComputed,
                                              name:
                                                "person[" +
                                                _vm.extra_tenants[_vm.i].id +
                                                "][working_contract_end_date]",
                                              isExtraInfo: true,
                                              isReadonly: true,
                                              placeholder:
                                                _vm.usersContractEndDatePlaceholder,
                                              isRequired: true
                                            }
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "extra-info" },
                                              [
                                                _c("i", {
                                                  staticClass: "icon-calendar"
                                                })
                                              ]
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          attrs: {
                                            type: "hidden",
                                            name:
                                              "person[" +
                                              _vm.extra_tenants[_vm.i].id +
                                              "][working_contract_end_date]"
                                          },
                                          domProps: {
                                            value: _vm.hiddenContractEndDate
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                471041834
                              ),
                              model: {
                                value: _vm.contractEndDate,
                                callback: function($$v) {
                                  _vm.contractEndDate = $$v
                                },
                                expression: "contractEndDate"
                              }
                            })
                          : _c("functional-calendar", {
                              staticClass:
                                "single-calendar min-w-[250px] md:w-full",
                              attrs: { configs: _vm.calendarConfigs },
                              on: {
                                choseDay: _vm.changeNewUserContractEndDate
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "datePickerInput",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "theme-input",
                                          {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "`required`"
                                              }
                                            ],
                                            attrs: {
                                              label: _vm.usersContractEndDate,
                                              value:
                                                _vm.contractEndDateNewUserComputed,
                                              name:
                                                "new_person[" +
                                                [_vm.i] +
                                                "][working_contract_end_date]",
                                              isExtraInfo: true,
                                              isReadonly: true,
                                              placeholder:
                                                _vm.usersContractEndDatePlaceholder,
                                              isRequired: true
                                            }
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "extra-info" },
                                              [
                                                _c("i", {
                                                  staticClass: "icon-calendar"
                                                })
                                              ]
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          attrs: {
                                            type: "hidden",
                                            name:
                                              "new_person[" +
                                              [_vm.i] +
                                              "][working_contract_end_date]"
                                          },
                                          domProps: {
                                            value:
                                              _vm.hiddenContractEndDateNewUser
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2962261098
                              ),
                              model: {
                                value: _vm.contractEndDateNewUser,
                                callback: function($$v) {
                                  _vm.contractEndDateNewUser = $$v
                                },
                                expression: "contractEndDateNewUser"
                              }
                            })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-8"
                  },
                  [
                    _vm.extra_tenants[_vm.i]
                      ? _c("theme-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "`required`"
                            }
                          ],
                          attrs: {
                            label: _vm.usersOccupation,
                            name:
                              "person[" +
                              _vm.extra_tenants[_vm.i].id +
                              "][occupation]",
                            isRequired: true,
                            placeholder: _vm.usersOccupationPlaceholder
                          },
                          model: {
                            value: _vm.extra_tenants[_vm.i].occupation,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.extra_tenants[_vm.i],
                                "occupation",
                                $$v
                              )
                            },
                            expression: "extra_tenants[i].occupation"
                          }
                        })
                      : _c("theme-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "`required`"
                            }
                          ],
                          attrs: {
                            label: _vm.usersOccupation,
                            name: "new_person[" + [_vm.i] + "][occupation]",
                            isRequired: true,
                            placeholder: _vm.usersOccupationPlaceholder
                          }
                        }),
                    _vm._v(" "),
                    _vm.extra_tenants[_vm.i]
                      ? _c(
                          "theme-input",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|numeric",
                                expression: "`required|numeric`"
                              }
                            ],
                            attrs: {
                              label: _vm.usersMonthlyIncome,
                              name:
                                "person[" +
                                _vm.extra_tenants[_vm.i].id +
                                "][income]",
                              isRequired: true,
                              isExtraInfo: true,
                              isExtraNote: true,
                              placeholder: _vm.usersMonthlyIncomePlaceholder
                            },
                            model: {
                              value: _vm.extra_tenants[_vm.i].income,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.extra_tenants[_vm.i],
                                  "income",
                                  $$v
                                )
                              },
                              expression: "extra_tenants[i].income"
                            }
                          },
                          [
                            _c("template", { slot: "extra-info" }, [
                              _vm._v("€")
                            ]),
                            _vm._v(" "),
                            _c("template", { slot: "extra-note" }, [
                              _vm._v(_vm._s(_vm.usersMonthlyIncomeNote))
                            ])
                          ],
                          2
                        )
                      : _c(
                          "theme-input",
                          {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|numeric",
                                expression: "`required|numeric`"
                              }
                            ],
                            attrs: {
                              label: _vm.usersMonthlyIncome,
                              name: "new_person[" + [_vm.i] + "][income]",
                              isRequired: true,
                              isExtraInfo: true,
                              isExtraNote: true,
                              placeholder: _vm.usersMonthlyIncomePlaceholder
                            }
                          },
                          [
                            _c("template", { slot: "extra-info" }, [
                              _vm._v("€")
                            ]),
                            _vm._v(" "),
                            _c("template", { slot: "extra-note" }, [
                              _vm._v(_vm._s(_vm.usersMonthlyIncomeNote))
                            ])
                          ],
                          2
                        ),
                    _vm._v(" "),
                    _vm.extra_tenants[_vm.i]
                      ? _c("theme-radios", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|make_choice",
                              expression: "`required|make_choice`"
                            }
                          ],
                          staticClass: "md:mb-8",
                          attrs: {
                            label: _vm.usersDoYouHaveGuarantorGeneral,
                            name:
                              "person[" +
                              _vm.extra_tenants[_vm.i].id +
                              "][guarantor]",
                            options: _vm.usersDoYouHaveGuarantorOptions,
                            value: _vm.extra_tenants[_vm.i].guarantor + ""
                          },
                          on: { input: _vm.triggerGuarantorForm }
                        })
                      : _c("theme-radios", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|make_choice",
                              expression: "`required|make_choice`"
                            }
                          ],
                          staticClass: "md:mb-8",
                          attrs: {
                            label: _vm.usersDoYouHaveGuarantorGeneral,
                            name: "new_person[" + [_vm.i] + "][guarantor]",
                            options: _vm.usersDoYouHaveGuarantorOptions
                          },
                          on: { input: _vm.triggerGuarantorForm }
                        }),
                    _vm._v(" "),
                    _vm.guarantor_form_state == 1
                      ? _c(
                          "div",
                          [
                            _vm.extra_tenants[_vm.i]
                              ? _c("theme-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|numeric",
                                      expression: "`required|numeric`"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.usersGuarantorIncome,
                                    name:
                                      "person[" +
                                      _vm.extra_tenants[_vm.i].id +
                                      "][guarantor_income]",
                                    placeholder:
                                      _vm.usersGuarantorIncomePlaceholder
                                  },
                                  model: {
                                    value:
                                      _vm.extra_tenants[_vm.i].guarantor_income,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.extra_tenants[_vm.i],
                                        "guarantor_income",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "extra_tenants[i].guarantor_income"
                                  }
                                })
                              : _c("theme-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|numeric",
                                      expression: "`required|numeric`"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.usersGuarantorIncome,
                                    name:
                                      "new_person[" +
                                      [_vm.i] +
                                      "][guarantor_income]",
                                    placeholder:
                                      _vm.usersGuarantorIncomePlaceholder
                                  }
                                })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.income_form_studying
            ? _c(
                "div",
                [
                  !_vm.income_form_work_business
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "grid grid-cols-1 gap-5 md:grid-cols-2 mb-6 md:gap-8 md:mb-8"
                        },
                        [
                          _vm.extra_tenants[_vm.i]
                            ? _c("theme-radios", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|make_choice",
                                    expression: "`required|make_choice`"
                                  }
                                ],
                                staticClass: "md:mb-8",
                                attrs: {
                                  label: _vm.usersDoYouHaveGuarantorGeneral,
                                  name:
                                    "person[" +
                                    _vm.extra_tenants[_vm.i].id +
                                    "][guarantor]",
                                  options: _vm.usersDoYouHaveGuarantorOptions,
                                  value: _vm.extra_tenants[_vm.i].guarantor
                                },
                                on: { input: _vm.triggerGuarantorForm }
                              })
                            : _c("theme-radios", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|make_choice",
                                    expression: "`required|make_choice`"
                                  }
                                ],
                                staticClass: "md:mb-8",
                                attrs: {
                                  label: _vm.usersDoYouHaveGuarantorGeneral,
                                  name:
                                    "new_person[" + [_vm.i] + "][guarantor]",
                                  options: _vm.usersDoYouHaveGuarantorOptions
                                },
                                on: { input: _vm.triggerGuarantorForm }
                              }),
                          _vm._v(" "),
                          _vm.guarantor_form_state == 1
                            ? _c(
                                "div",
                                [
                                  _vm.extra_tenants[_vm.i]
                                    ? _c("theme-input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|numeric",
                                            expression: "`required|numeric`"
                                          }
                                        ],
                                        attrs: {
                                          label: _vm.usersGuarantorIncome,
                                          name:
                                            "person[" +
                                            _vm.extra_tenants[_vm.i].id +
                                            "][guarantor_income]",
                                          isRequired: true,
                                          placeholder:
                                            _vm.usersGuarantorIncomePlaceholder
                                        },
                                        model: {
                                          value:
                                            _vm.extra_tenants[_vm.i]
                                              .guarantor_income,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.extra_tenants[_vm.i],
                                              "guarantor_income",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "extra_tenants[i].guarantor_income"
                                        }
                                      })
                                    : _c("theme-input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|numeric",
                                            expression: "`required|numeric`"
                                          }
                                        ],
                                        attrs: {
                                          label: _vm.usersGuarantorIncome,
                                          name:
                                            "new_person[" +
                                            [_vm.i] +
                                            "][guarantor_income]",
                                          isRequired: true,
                                          placeholder:
                                            _vm.usersGuarantorIncomePlaceholder
                                        }
                                      })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.extra_tenants[_vm.i]
                    ? _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "`required`"
                          }
                        ],
                        attrs: {
                          label: _vm.usersStudy,
                          name:
                            "person[" +
                            _vm.extra_tenants[_vm.i].id +
                            "][study]",
                          isRequired: true,
                          placeholder: _vm.usersStudyPlaceholder
                        },
                        model: {
                          value: _vm.extra_tenants[_vm.i].study,
                          callback: function($$v) {
                            _vm.$set(_vm.extra_tenants[_vm.i], "study", $$v)
                          },
                          expression: "extra_tenants[i].study"
                        }
                      })
                    : _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "`required`"
                          }
                        ],
                        attrs: {
                          label: _vm.usersStudy,
                          name: "new_person[" + [_vm.i] + "][study]",
                          isRequired: true,
                          placeholder: _vm.usersStudyPlaceholder
                        }
                      })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.income_form_any
            ? _c(
                "div",
                [
                  _vm.extra_tenants[_vm.i]
                    ? _c("theme-textarea", {
                        attrs: {
                          label: _vm.usersExtraInformationIncome,
                          name:
                            "person[" +
                            _vm.extra_tenants[_vm.i].id +
                            "][income_note]",
                          placeholder:
                            _vm.usersExtraInformationIncomePlaceholder
                        },
                        model: {
                          value: _vm.extra_tenants[_vm.i].income_note,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.extra_tenants[_vm.i],
                              "income_note",
                              $$v
                            )
                          },
                          expression: "extra_tenants[i].income_note"
                        }
                      })
                    : _c("theme-textarea", {
                        attrs: {
                          label: _vm.usersExtraInformationIncome,
                          name: "new_person[" + [_vm.i] + "][income_note]",
                          placeholder:
                            _vm.usersExtraInformationIncomePlaceholder
                        }
                      })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "theme-details-form__living-situation details-section" },
        [
          _c("h2", { staticClass: "section-title-xs" }, [
            _vm._v(
              _vm._s(_vm.subscriptions) +
                " " +
                _vm._s(_vm.i + 2) +
                " " +
                _vm._s(_vm.usersLandlordLabel)
            )
          ]),
          _vm._v(" "),
          _vm.extra_tenants[_vm.i]
            ? _c("theme-radios", {
                attrs: {
                  name:
                    "person[" +
                    _vm.extra_tenants[_vm.i].id +
                    "][landlord_status]",
                  options: _vm.usersLandlordOptions,
                  columnDirection: true
                },
                on: { input: _vm.triggerLandlordType },
                model: {
                  value: _vm.extra_tenants[_vm.i].landlord_status,
                  callback: function($$v) {
                    _vm.$set(_vm.extra_tenants[_vm.i], "landlord_status", $$v)
                  },
                  expression: "extra_tenants[i].landlord_status"
                }
              })
            : _c("theme-radios", {
                attrs: {
                  name: "new_person[" + [_vm.i] + "][landlord_status]",
                  options: _vm.usersLandlordOptions,
                  columnDirection: true
                },
                on: { input: _vm.triggerLandlordType }
              }),
          _vm._v(" "),
          _vm.landlord_type_state == "renting_property"
            ? _c(
                "div",
                {
                  staticClass: "grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-8"
                },
                [
                  _vm.extra_tenants[_vm.i]
                    ? _c("theme-input", {
                        attrs: {
                          label:
                            _vm.locales &&
                            _vm.locales.users &&
                            _vm.locales.users.landlord_name,
                          name:
                            "person[" +
                            _vm.extra_tenants[_vm.i].id +
                            "][landlord_name]",
                          placeholder: _vm.usersLandlordNamePlaceholder
                        }
                      })
                    : _c("theme-input", {
                        attrs: {
                          label:
                            _vm.locales &&
                            _vm.locales.users &&
                            _vm.locales.users.landlord_name,
                          name: "new_person[" + [_vm.i] + "][landlord_name]",
                          placeholder: _vm.usersLandlordNamePlaceholder
                        }
                      }),
                  _vm._v(" "),
                  _vm.extra_tenants[_vm.i]
                    ? _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "email",
                            expression: "`email`"
                          }
                        ],
                        attrs: {
                          label:
                            _vm.locales &&
                            _vm.locales.users &&
                            _vm.locales.users.landlord_email,
                          name:
                            "person[" +
                            _vm.extra_tenants[_vm.i].id +
                            "][landlord_email]",
                          placeholder: _vm.usersLandlordEmailPlaceholder
                        }
                      })
                    : _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "email",
                            expression: "`email`"
                          }
                        ],
                        attrs: {
                          label:
                            _vm.locales &&
                            _vm.locales.users &&
                            _vm.locales.users.landlord_email,
                          name: "new_person[" + [_vm.i] + "][landlord_email]",
                          placeholder: _vm.usersLandlordEmailPlaceholder
                        }
                      }),
                  _vm._v(" "),
                  _vm.extra_tenants[_vm.i]
                    ? _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "phone_number",
                            expression: "`phone_number`"
                          }
                        ],
                        attrs: {
                          label:
                            _vm.locales &&
                            _vm.locales.users &&
                            _vm.locales.users.landlord_phone_number,
                          name:
                            "person[" +
                            _vm.extra_tenants[_vm.i].id +
                            "][landlord_phone_number]",
                          placeholder: _vm.usersLandlordPhonePlaceholder
                        }
                      })
                    : _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "phone_number",
                            expression: "`phone_number`"
                          }
                        ],
                        attrs: {
                          label:
                            _vm.locales &&
                            _vm.locales.users &&
                            _vm.locales.users.landlord_phone_number,
                          name:
                            "new_person[" +
                            [_vm.i] +
                            "][landlord_phone_number]",
                          placeholder: _vm.usersLandlordPhonePlaceholder
                        }
                      })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f3e2a26", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f3e2a26","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ThemeDetailsInnerForm.vue
// module id = 750
// module chunks = 1